<ion-icon 
    [src]="src"
    [ngStyle]="style"
/>